import React from 'react';
import { Helmet } from 'react-helmet-async';
import { Link } from 'react-router-dom';

export const NotFound: React.FC = () => {
    return (
        <>
            <Helmet>
                <title>404 - Page Not Found | ForexFundAI</title>
                <meta name="robots" content="noindex, follow" />
            </Helmet>
            <div className="min-h-[70vh] flex flex-col items-center justify-center text-center px-4">
                <h1 className="text-6xl font-bold text-white mb-4">404</h1>
                <p className="text-xl text-finance-text mb-8">
                    The page you are looking for does not exist or has been moved.
                </p>
                <Link
                    to="/"
                    className="bg-finance-accent text-finance-dark px-8 py-3 rounded-md font-semibold hover:bg-yellow-500 transition-colors"
                >
                    Return Home
                </Link>
            </div>
        </>
    );
};
